/* eslint-disable angular/constant-name */

angular.module("dx.webapp.masterTools").constant("UserMergeTypeEnum",
	Object.freeze({
		STUDENT: "student",
		FACULTY: "faculty",
	})
);
